export default "__VITE_ASSET__DwTPu$xP__"